"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageRouter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _PageManager = require("./PageManager");
var _eventer = require("@blockwell/eventer");
var _reactivity = require("@vue/reactivity");
var _variables = require("@blockwell/variables");
class PageRouter {
  static parsePath(path) {
    var _parts$shift;
    let parts = path.split("/").filter(it => !!it);
    let name = (_parts$shift = parts.shift()) === null || _parts$shift === void 0 ? void 0 : _parts$shift.toLowerCase();
    return {
      parts,
      name
    };
  }
  get activePageName() {
    var _this$activePage;
    return (_this$activePage = this.activePage) === null || _this$activePage === void 0 ? void 0 : _this$activePage.name;
  }
  constructor(registry, param, specs) {
    (0, _defineProperty2.default)(this, "pages", void 0);
    (0, _defineProperty2.default)(this, "activePage", void 0);
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer());
    (0, _defineProperty2.default)(this, "param", void 0);
    (0, _defineProperty2.default)(this, "effectHolder", {
      effect: null,
      title: null,
      ref: null
    });
    (0, _defineProperty2.default)(this, "lastPath", []);
    this.registry = registry;
    // Freeze to avoid pollution by reactivity systems
    this.pages = specs.map(it => {
      let page = Object.freeze(new _PageManager.PageManager(it));
      page.attach(registry);
      return page;
    });
    this.param = (0, _reactivity.reactive)(param || {});
    this.effectHolder.ref = new _variables.VariableReference(registry.variableTypes.get("template"), {
      template: this.param.title
    }, true);
  }
  addPage(page) {
    if (!this.pages.find(it => it === page)) {
      var _this$registry;
      page.attach(this.registry);
      this.pages.push(page);
      (_this$registry = this.registry) === null || _this$registry === void 0 ? void 0 : _this$registry.change({
        type: "page",
        op: "add",
        name: page.name
      });
    }
  }
  removePage(page) {
    let index = this.pages.findIndex(it => it === page);
    if (index > -1) {
      var _this$registry2;
      this.pages.splice(index, 1);
      (_this$registry2 = this.registry) === null || _this$registry2 === void 0 ? void 0 : _this$registry2.change({
        type: "page",
        op: "remove",
        name: page.name
      });
    }
    if (page === this.activePage) {
      this.activate(null, this.lastPath);
    }
  }
  route(path) {
    const {
      parts,
      name
    } = PageRouter.parsePath(path);
    this.lastPath = parts;
    if (name) {
      let page = this.pages.find(it => it.name === name);
      this.activate(page, parts);
    } else {
      this.activate(null, parts);
    }
  }
  triggerLayout() {
    this.events.emit("layout", this.activePage.layout);
  }
  getPages() {
    return [...this.pages];
  }
  isNameAvailable(name, ignore) {
    return !this.pages.find(it => it.name === name && it !== ignore);
  }
  activate(page, path) {
    if (!page && !this.activePage) {
      return;
    }
    if (page === this.activePage) {
      page.updatePath(path);
      return;
    }
    const old = this.activePage;
    this.activePage = page;
    this.events.emit("activate", {
      page,
      path
    });
    if (old) {
      // Stop the old page after the DOM tree has changed
      setTimeout(() => {
        old.stop();
      }, 5);
    }
  }
  triggerActivate(path) {
    if (this.activePage) {
      this.activePage.stop();
    }
    const {
      parts
    } = PageRouter.parsePath(path);
    this.events.emit("activate", {
      page: this.activePage,
      path: parts
    });
  }
  onParam(listener) {
    this.events.on("param", listener);
    this.emitParam();
  }
  offParam(listener) {
    this.events.off("param", listener);
  }
  updateParam(key, value) {
    var _this$effectHolder$re, _this$effectHolder$re2, _this$registry3;
    switch (key) {
      case "title":
        this.param[key] = value;
        (_this$effectHolder$re = this.effectHolder.ref) === null || _this$effectHolder$re === void 0 ? void 0 : _this$effectHolder$re.updateParameter("template", value);
        (_this$effectHolder$re2 = this.effectHolder.ref) === null || _this$effectHolder$re2 === void 0 ? void 0 : _this$effectHolder$re2.triggerDeps();
        break;
      default:
        this.param[key] = value;
        break;
    }
    (_this$registry3 = this.registry) === null || _this$registry3 === void 0 ? void 0 : _this$registry3.change({
      type: "palette",
      op: "update",
      name: key
    });
  }
  emitParam() {
    if (!this.effectHolder.effect) {
      this.effectHolder.effect = (0, _reactivity.effect)(() => {
        this.events.emit("param", this.param);
      });
    } else {
      this.effectHolder.effect();
    }
  }
  onTitle(listener) {
    this.events.on("title", listener);
    this.emitTitle();
  }
  offTitle(listener) {
    this.events.off("title", listener);
  }
  emitTitle() {
    if (!this.effectHolder.title) {
      let ctx = this.registry.blocks.root.context;
      ctx.addVariable(1, null, this.effectHolder.ref, "palette title");
      this.effectHolder.title = (0, _reactivity.effect)(() => {
        if (this.activePage && this.activePage.root) {
          let value = this.activePage.title.value();
          this.events.emit("title", _variables.vals.stringValue(value));
        } else {
          let value = this.effectHolder.ref.value();
          this.events.emit("title", _variables.vals.stringValue(value));
        }
      });
    } else {
      this.effectHolder.title();
    }
  }
  toJSON() {
    return this.pages.map(it => it.toJSON());
  }
  destroy() {
    var _this$effectHolder$ef, _this$effectHolder$ef2, _this$effectHolder$ti, _this$effectHolder$ti2;
    (_this$effectHolder$ef = this.effectHolder.effect) === null || _this$effectHolder$ef === void 0 ? void 0 : (_this$effectHolder$ef2 = _this$effectHolder$ef.effect) === null || _this$effectHolder$ef2 === void 0 ? void 0 : _this$effectHolder$ef2.stop();
    this.effectHolder.effect = null;
    (_this$effectHolder$ti = this.effectHolder.title) === null || _this$effectHolder$ti === void 0 ? void 0 : (_this$effectHolder$ti2 = _this$effectHolder$ti.effect) === null || _this$effectHolder$ti2 === void 0 ? void 0 : _this$effectHolder$ti2.stop();
    this.effectHolder.title = null;
    for (let page of this.pages) {
      page.destroy();
    }
    this.activePage = null;
    this.events.emit("activate", {
      page: null,
      path: []
    });
    this.events.clearListeners();
    this.pages = [];
  }
}
exports.PageRouter = PageRouter;
//# sourceMappingURL=PageRouter.js.map